import type { ReactNode } from "react";

import styles from "./style.module.scss";

interface ScopeSectionProps {
    icon: ReactNode;
    label: string;
    description: string;
    children: ReactNode;
}

const ScopeSection = ({ icon, label, description, children }: ScopeSectionProps) => {
    return (
        <div className={styles["scope-section"]}>
            <div className={styles["header"]}>
                <div className={styles["label-container"]}>
                    {icon}
                    <label className={styles["label"]}>{label}</label>
                </div>
            </div>
            {children}
            <p className={styles["description"]}>{description}</p>
        </div>
    );
};

export default ScopeSection;
